import React from 'react';
import { useAuth } from '../context/AuthContext';

const MyPage = () => {
    const { profile, logOut } = useAuth();

    if (!profile) {
        return <div>로그인 후 이용해주세요.</div>;
    }

    return (
        <div>
            <span>{profile?.name} 님의 마이페이지</span>
            <button onClick={logOut}>로그아웃</button>
        </div>
    )
}

export default MyPage;